var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFlag = function SvgFlag(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "none",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.35 1.034A4.685 4.685 0 0 0 2.5.542l-.563.174a.667.667 0 0 0-1.27.283v12a.667.667 0 1 0 1.333 0V8.83c.117-.031.223-.07.305-.101.075-.028.148-.061.223-.087a3.727 3.727 0 0 1 3.041.295 5.06 5.06 0 0 0 4.006.44l.873-.27c.527-.163.886-.65.886-1.201V1.989a.945.945 0 0 0-.18-.57.9.9 0 0 0-.482-.327c-.282-.08-.572-.028-.745.013a4.385 4.385 0 0 0-.54.173c-.094.035-.186.076-.28.108a3.352 3.352 0 0 1-2.756-.352Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFlag);
export default ForwardRef;